import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import prepareHeaders from 'services/utils/prepare-headers';

export const dataSetApi = createApi({
  reducerPath: 'dataSetApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'api/dataSet', prepareHeaders }),
  endpoints: (builder) => ({
    getDataSet: builder.query<object, string>({
      query: (id) => `getDataSet?type=${id}`,
      transformResponse: (rawResult: { data: object }) => rawResult.data,
    }),
  }),
});

export const { useGetDataSetQuery } = dataSetApi;
